/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namnth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
const initData = {
    type: '1',
    client_code: '10001001',
    client_nm: '株式会社ムーヴ',
    visit_date: '2025/08/28',
    report_date: '2025/08/28',
    reporter_code: '880143',
    reporter_nm: '岡本　竣太',
    checklist:
        '1. 報告は営業日に記載する事。\n' +
        '2. 取引先からの要望事項等があれば、内容をタスク設定して報\n' +
        '　告・相談・回答で完了とする事。\n' +
        '3. 先方資料がある場合、添付する事。\n' +
        '4. タスクを設定する場合は、日、時間、担当者を設定する事。\n' +
        '5. 新たな名刺がある場合はeightに登録する事。\n' +
        '　（もしeight権者で無い場合は、eight権者へ依頼する）\n',
    sales_matter_content: ['1', '2', '6', '7', '8'],
    sales_matter_note: '無し',
    comment_date: '2025/08/29',
    comment_number: '856739',
    comment_person: '伊藤　蓮',
    comment_content: '',
    purchasing_people: [
        {
            no: '01',
            start_date: '2025/06/01',
            person_in_charge: '佐藤',
            filename: '名刺.jpg',
            file: '',
            note: 'note',
            showImage: false,
            disable: { start_date: true, person_in_charge: true, note: true }
        },
        {
            no: '02',
            start_date: '2023/05/01',
            person_in_charge: '國末',
            filename: '名刺.jpg',
            file: '',
            note: 'note',
            showImage: false,
            disable: { start_date: true, person_in_charge: true, note: true }
        }
    ],
    report_content: '',
    reporting_filename: '',
    reporting_file: '',
    visit_reports: [
        {
            visit_date: '2025/06/01',
            last_updated_date: '2025/06/01',
            reporter_code: '143256',
            reporter_nm: '古屋',
            business_matter:
                '・お客様登録書\n' + '・業務委託基本契約書\n' + '・業務依頼書（個別契約書）\n' + '・営業事例説明\n' + '・他社使用状況ヒアリング',
            business_note: '特になし',
            business_content:
                '訪問。\n' +
                '対応は、問題無い。\n' +
                '依頼書送ってるのが女性事務員なのでレクチャーしてくれれば良い。\n' +
                '\n' +
                '熱中症の予防に関して\n' +
                '改めて協力をあおぐ。\n' +
                '作業前ミーティング時にしっかりと話を入れてる。\n' +
                '水分持込NGなので、荷物置き場でリーダー報告で対応してくれれば良い。\n' +
                '飲物の予備やアイシングなども用意している。\n' +
                '万が一の時は、百貨店の涼しいところで休ませる。\n' +
                'もしくは救急を呼ぶ。\n',
            filename: '名刺.pdf ',
            file: ''
        },
        {
            visit_date: '2025/05/27',
            last_updated_date: '2025/05/27',
            reporter_code: '143256',
            reporter_nm: '古屋',
            business_matter: '・お客様登録書\n' + '・業務委託基本契約書\n',
            business_note: '特になし',
            business_content:
                '小谷野Cと引継ぎで訪問。\n' +
                '佐藤様、挨拶＆名刺交換\n' +
                '\n' +
                'ムーヴで慣れてもらってる近鉄百貨店　四日市は他派遣の料金によって減らす可能性も有り。\n' +
                '\n' +
                '料金の話。\n' +
                '時給換算からA表の話。2025/7〜を打診。\n' +
                '佐藤様の一存では決めれないのでデータ元手に上長と話をする。との事。\n' +
                '→佐藤様は了承済みA表2引きにて/小谷野\n',
            filename: '名刺.pdf ',
            file: ''
        }
    ]
};
export default {
    namespaced: true,
    state: {
        data: JSON.parse(JSON.stringify(initData)),
        paginationData: {
            pageNo: 1,
            pageSize: 10,
            totalRows: 2,
            msgNoData: '該当するデータが存在しません。'
        },
        optionGroup: {
            sales_matter_content: [
                { code: 1, name: 'お客様登録書（紙面orQR）' },
                { code: 2, name: '業務委託基本契約書' },
                { code: 3, name: '請負基本料金表（A表・B表・OP・QR）' },
                { code: 4, name: 'TSR与信審査' },
                { code: 5, name: '請求・支払い方法（売掛・NP）' },
                { code: 6, name: '業務依頼書（個別契約書）※QR' },
                { code: 7, name: '営業事例説明' },
                { code: 8, name: '他社使用状況ヒアリング' }
            ],
            pageSize: [
                { code: 5, name: '5' },
                { code: 10, name: '10' },
                { code: 50, name: '50' }
            ]
        }
    },
    mutations: {
        resetFormData(state, type) {
            state.data = JSON.parse(JSON.stringify(initData));
            state.data.type = type;
        }
    },
    actions: {}
};
